import createDisplayName from "../../../../fabrics/createDisplayName";
import { HEADER_SCHEVRON_DISPLAY_NAME } from "../HeaderSchevron";

export const createDisplayNameForHeaderSchevron = createDisplayName(
    HEADER_SCHEVRON_DISPLAY_NAME,
);
